<template>

  <v-navigation-drawer
    v-if="getData"
    :class="barOpen ? 'white' : 'white'"
    v-model="barOpen"
    
    hide-overlay
    right
    floating
    absolute
    :width="barOpen ? barSize : 0"
    disable-resize-watcher
  >

    <scroll-area>

      <template slot="header">

        <v-toolbar  dense flat>

          <v-toolbar-title>
            <span class="body-2 text-uppercase">{{$t('select elements to add to')}} {{ getData.name }}</span>       
          </v-toolbar-title>

          <v-layout fill-height justify-end>

            <v-dialog v-model="dialog.confirm" persistent max-width="290">
              <template v-slot:activator="{ on }">
                <v-layout fill-height justify-end>

                  <v-tooltip dark color="secondary" left>
                      <v-btn :data-testid="$options.name + 'v-btn' + 'delete'" slot="activator" icon v-on="on">
                        <svg-icon
                          :color="'red'"
                          :name="'basket'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{$t('delete')}}</span>
                  </v-tooltip>

                </v-layout>
              </template>

              <v-card>

                <v-card-title class="blue lighten-3 caption">

                  <v-layout fill-height justify-space-around>

                    <v-flex shrink>
                      {{$t('confirmation request')}}
                    </v-flex>

                  </v-layout>

                </v-card-title>

                <v-card-text>
                  <v-layout class="text-truncate" px-2 fill-height justify-center>
                    <span class="text-truncate">{{$t('remove')}} {{ getData.name }}</span>
                    <v-flex shrink>?</v-flex>
                  </v-layout>
                </v-card-text>


                <v-card-actions>

                  <v-layout px-2>

                    <v-btn :data-testid="$options.name + 'v-btn' + 'dialogconfirm--false'" small block color="grey lighten-3"  text @click="dialog.confirm = false">{{$t('no')}}</v-btn>

                    <v-btn :data-testid="$options.name + 'v-btn' + 'deleteService'" small block color="error" text @click="deleteService()">{{$t('yes')}}</v-btn>

                  </v-layout>

                </v-card-actions>

              </v-card>

            </v-dialog>

            <v-tooltip v-if="getDevices.length" color="secondary" left>
              <v-btn :data-testid="$options.name + 'v-btn' + 'submit'" v-if="getDevices.length" icon flat slot="activator" @click="() => submit()">
                <svg-icon
                  :color="'primary'"
                  :name="'done'"
                  width="20"
                />
              </v-btn>
              <span v-if="getDevices.length">{{ $t('add') }}</span>
            </v-tooltip>

            <v-tooltip color="secondary" left>
              <v-btn :data-testid="$options.name + 'v-btn' + 'close'" icon flat slot="activator" @click="close(); $store.dispatch('setEditMode', false)">
                <svg-icon
                  :color="'primary'"
                  :name="'close'"
                  width="20"
                />
              </v-btn>
              <span>{{ $t('cancel') }}</span>
            </v-tooltip>

          </v-layout>

        </v-toolbar>

      </template>

      <template slot="body">

        <v-container fluid fill-height ma-0 pa-0>

          <v-layout fill-height>

            <v-flex xs12 pa-0>

              <v-layout column fill-height justify-start>

                <equipment-tree
                  v-if="open"
                  :hideClass="['folder', 'service']"
                  :approveCls="['device']"
                  mode="service"
                  @add="(payload) => onAdd(payload)"
                />

              </v-layout>

            </v-flex>

            <v-flex v-if="getDevices.length" justify-start xs4 pa-0>

              <v-layout column fill-height justify-start>

                <scroll-area>

                  <template slot="header">

                    <v-toolbar class="primary" dense flat dark>

                      <v-toolbar-title>
                        <span class="body-2 text-uppercase">{{$t('selected elements')}}</span>                            
                      </v-toolbar-title>

                    </v-toolbar>

                  </template>

                  <template slot="body">

                    <v-layout fill-height justify-start>

                      <v-layout column fill-height justify-start>

                        <v-list subheader>
                          <v-list-tile
                            v-for="(item, index) in getDevices"
                            :key="index"
                            avatar--
                            @click=""
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ item.name }}
                              </v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                              <v-tooltip left>
                                <v-btn :data-testid="$options.name + 'v-btn' + 'onRemove-item'" icon flat slot="activator" @click.stop="() => onRemove(item)">
                                  <svg-icon
                                    :color="'red'"
                                    :name="'basket'"
                                    width="20"
                                  />
                                </v-btn>
                                <span>{{ $t('cancel') }}</span>
                              </v-tooltip>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>

                      </v-layout>

                    </v-layout>

                  </template>

                </scroll-area>

              </v-layout>

            </v-flex>

          </v-layout>

        </v-container>

      </template>

    </scroll-area>

  </v-navigation-drawer>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { CCMDBObject } from '@entcor/ebridge'
import equipmentTree from '@/nms/components/equipment/equipment-tree.vue'

// Типы
interface DeviceItem {
  $id?: string
  id?: string
  name?: string
  cls?: string
  tags?: string[]
  [key: string]: any
}

interface ServiceData {
  $id?: string
  id?: string
  name?: string
  cls?: string
  template?: string
  [key: string]: any
}

interface ModelField {
  types: any[]
  type: string
  fields: any[]
  models?: any[]
  model?: string
}

interface ModelData {
  location: ModelField
  cabinet: ModelField
  device: ModelField & { models: any[]; model: string }
  module: ModelField & { models: any[]; model: string }
}

interface CurrentState {
  entity: string
}

interface StateMessages {
  error: Record<string, any>
}

interface ComponentData {
  barOpen: boolean
  barSize: number
  showDoneButton: boolean
  devices: DeviceItem[]
  removeDevices: DeviceItem[]
  dialog: { confirm: boolean }
  entity: {
    type: Record<string, any>
    types: Array<{ value: string; name: string }>
  }
  model: ModelData
  center: [number, number]
  current: CurrentState
  state: { messages: StateMessages }
  meta: Record<string, any>
  approveCls: [string]
}

export default Vue.extend({
  name: 'CREATE_SERVICE_BAR',

  components: {
    scrollArea,
    svgIcon,
    equipmentTree
  },

  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    mode: {
      type: Boolean,
      default: () => false
    },
    data: {
      type: Object as () => ServiceData,
      default: () => ({})
    },
  },

  data(): ComponentData {
    return {
      barOpen: false,
      barSize: 0,
      showDoneButton: false,
      devices: [],
      removeDevices: [],
      dialog: { confirm: false },
      entity: {
        type: {},
        types: [
          { value: 'device', name: 'Устройство' },
          { value: 'module', name: 'Модуль' },
        ],
      },
      model: {
        location: { types: [], type: '', fields: [] },
        cabinet: { types: [], type: '', fields: [] },
        device: { types: [], type: '', models: [], model: '', fields: [] },
        module: { types: [], type: '', models: [], model: '', fields: [] },
      },
      center: [55.755919, 37.617589],
      current: { entity: '' },
      state: { messages: { error: {} } },
      meta: {},
      approveCls: ['device']
    }
  },

  computed: {
    getData(): ServiceData {
      return this.data
    },
    editMode(): boolean {
      return this.mode
    },
    getDevices(): DeviceItem[] {
      return this.devices
    },
    getRemoveDevices(): DeviceItem[] {
      return this.removeDevices
    },
    getApproveCls(): [string] {
      return this.approveCls
    },
  },

  watch: {
    open: {
      handler(newVal: boolean): void {
        if (this.$parent.$refs?.['barWrapper']) {
          this.barSize = (this.$parent.$refs['barWrapper'] as HTMLElement).clientWidth
        } else if (this.$parent.$parent?.$refs?.['bar_wrapper']) {
          this.barSize = (this.$parent.$parent.$refs['bar_wrapper'] as HTMLElement).clientWidth
        }
        console.log('WATCH', 'CREATE_SERVICE_BAR', 'open newVal', newVal)
        if (newVal) {
          this.reset()
          this.setup()
        }
        this.barOpen = newVal
      },
      deep: true
    },
    mode: {
      handler(newVal: boolean): void {
        console.log('WATCH', 'CREATE_SERVICE_BAR', 'mode', this.data)
      },
      deep: true
    },
    data: {
      handler(): void {
        if (this.open) {
          this.reset()
          this.setup()
        }
      },
      deep: true
    },
    'current.entity': {
      async handler(newVal: string): Promise<void> {
        console.log('CREATE_SERVICE_BAR', 'WATCH', 'current.entity', 'newVal', newVal)
      },
      deep: true
    },
  },

  created(): void {
    console.log('CREATE_SERVICE_BAR', 'getData', this.getData)
  },

  mounted(): void {
    document.addEventListener('keyup', this.closeOnESC)
    window.addEventListener('resize', this.resizeHandler)
  },

  beforeDestroy(): void {
    document.removeEventListener('keyup', this.closeOnESC)
    window.removeEventListener('resize', this.resizeHandler)
  },

  methods: {
    async setup(): Promise<void> {
      await this.loadMeta()
      await this.loadDevices()
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        this.meta = await this.getData.meta()
        
        if (this.meta?.refs?.length && this.getData.cls === 'service') {
          console.log('CREATE_SERVICE_BAR loadMeta', 'meta', this.meta)
          let componentRef = this.meta.refs.find(ref => ref.name == 'component')
          if(componentRef) {
            console.log('CREATE_SERVICE_BAR loadMeta', 'componentRef', componentRef)
            if(componentRef.cls && Array.isArray(componentRef.cls)) {
              this.approveCls = componentRef.cls
            }
            else {
              this.approveCls = []
              this.approveCls.push(componentRef.cls)
            }
          }
        }
      } catch (error) {
        console.error('loadMeta error', error)
      }
    },

    async loadDevices(): Promise<void> {
      try {
        if (this.getData.cls === 'service') {
          const service = this.getData._cmdb_ ? this.getData : await this.$bridge.getObjectById(this.getData.$id)
          console.log('CREATE_SERVICE_BAR loadDevices', 'service', service)
          let devices = await service.getRefs()
          if(devices) {
            this.devices = devices
          }
          console.log('CREATE_SERVICE_BAR loadDevices', 'this.devices', this.devices)
        }
      } catch (err) {
        console.error('loadDevices error', err)
      }
    },
    
    // async loadDevices(): Promise<void> {
    //   try {
    //     if (this.getData.cls === 'service' && this.getData.template) {
    //       console.log('CREATE_SERVICE_BAR loadDevices', 'service', this.getData)
    //       const query = {
    //         id: ['class:device', 'class:module'],
    //         notNull: true,
    //         filter: { tags: this.getData.template },
    //         data: { namePath: true, children: false }
    //       }

    //       await this.$bridge.cmdbQuery(query).then(objects => {
    //         console.log('objects', objects)
    //         if (objects?.length) {
    //           this.devices = objects
    //         }
    //       })

    //       console.log('CREATE_SERVICE_BAR loadDevices', 'this.devices', this.devices)
    //     }
    //   } catch (err) {
    //     console.error('loadDevices error', err)
    //   }
    // },

    async submit(): Promise<void> {
      console.log('CREATE_SERVICE_BAR', 'submit', 'this.getDevices', this.getDevices)
      console.log('CREATE_SERVICE_BAR', 'submit', 'this.getData', this.getData)
      // return
      // if (!this.getData.template) return
      
      try {
        this.setLoader('submitCreateLocation', true)

        const refs$: any[] = []
        this.getDevices.forEach(device => {
          const ref$ = {
            ref: 'component',
            $id: device.$id
          }
          refs$.push(ref$)
        })
        let data$ = {}
        data$.refs = refs$

        const service = this.getData._cmdb_ ? this.getData : await this.$bridge.getObjectById(this.getData.$id)
        const u = await service.update(data$)
        if (u) {
          this.$dialog.notify.success(`Сервис ${service.name} успешно обновлён`, {
            timeout: 5000
          })
          console.log('CREATE_SERVICE_BAR', 'submit', 'u', u)
        } else {
          this.$dialog.notify.error('Ошибка добавления устройства в сервис', { timeout: 5000 })
          return
        }
        





        // for (const device of this.getDevices) {
        //   console.log('CREATE_SERVICE_BAR', 'submit', 'device', device)
        //   const tags = device.tags?.length ? [...device.tags] : []
          
        //   if (!tags.some(tag => tag === this.getData.template)) {
        //     console.log('find', tags)
        //     tags.push(this.getData.template!)

        //     const data$ = { tags }
        //     console.log('CREATE_SERVICE_BAR', 'submit', 'data$', data$)
        //     const obj$ = new CCMDBObject({ ...device })
        //     console.log('CREATE_SERVICE_BAR', 'submit', 'obj$', obj$)
            
        //     if (obj$) {
        //       const u = await obj$.update(data$)
        //       if (u) {
        //         this.$dialog.notify.success(`Объект ${obj$.name} успешно добавлен в сервис ${this.getData.name}`, {
        //           timeout: 5000
        //         })
        //         console.log('CREATE_SERVICE_BAR', 'submit', 'u', u)
        //       } else {
        //         this.$dialog.notify.error('Ошибка добавления устройства в сервис', { timeout: 5000 })
        //         return
        //       }
        //     } else {
        //       this.$dialog.notify.error('Ошибка выбора устройства', { timeout: 5000 })
        //       return
        //     }
        //   }
        // }

        // if (this.editMode) {
        //   for (const device of this.getRemoveDevices) {
        //     console.log('CREATE_SERVICE_BAR', 'submit', 'device remove', device)
        //     if (!device.tags?.length) return
        //     if (!device.tags.some(tag => tag === this.getData.template)) return
            
        //     const tags = device.tags.filter(tag => tag !== this.getData.template)
        //     console.log('CREATE_SERVICE_BAR', 'submit', 'device remove find', device)

        //     const data$ = { tags }
        //     const obj$ = new CCMDBObject({ ...device })
            
        //     if (obj$) {
        //       const u = await obj$.update(data$)
        //       if (u) {
        //         this.$dialog.notify.success(`Объект ${obj$.name} успешно удалён из сервиса ${this.getData.name}`, {
        //           timeout: 5000
        //         })
        //         console.log('CREATE_SERVICE_BAR', 'submit', 'u', u)
        //       } else {
        //         this.$dialog.notify.error('Ошибка удаления устройства из сервиса', { timeout: 5000 })
        //         return
        //       }
        //     } else {
        //       this.$dialog.notify.error('Ошибка выбора устройства', { timeout: 5000 })
        //       return
        //     }
        //   }
        // }

        this.$emit('update')
        this.reset()
        this.setLoader('submitCreateLocation', false)
        this.$store.state.auth.lock = false
        this.close()
      } catch (err) {
        console.error('CATCH', 'CREATE_SERVICE_BAR', 'submit', err)
        this.$errorHandler(err)
        this.setLoader('submitCreateLocation', false)
        this.$store.state.auth.lock = false
      }
    },

    closeOnESC(e: KeyboardEvent): void {
      if (e.which === 27 || e.keyCode === 27) {
        e.stopPropagation()
      }
    },

    resizeHandler(): void {
      if (this.$parent.$refs?.['barWrapper']) {
        this.barSize = (this.$parent.$refs['barWrapper'] as HTMLElement).clientWidth
      }
    },

    onAdd(val: DeviceItem): void {
      if (!this.devices.some(device => device.$id === val.$id)) {
        this.devices.push(val)
      }
      console.log('CREATE_SERVICE_BAR', 'onAdd', 'this.devices', this.devices)
    },

    onRemove(val: DeviceItem): void {
      console.log('CREATE_SERVICE_BAR', 'onRemove', 'val', val)
      const i = this.devices.findIndex(device => device.$id === val.$id)
      if (i >= 0) {
        this.devices.splice(i, 1)
      }
      console.log('CREATE_SERVICE_BAR', 'onRemove', 'this.devices', this.devices)

      if (!this.removeDevices.some(device => device.$id === val.$id)) {
        this.removeDevices.push(val)
      }
      console.log('CREATE_SERVICE_BAR', 'onRemove', 'this.removeDevices', this.removeDevices)
    },

    async deleteService(): Promise<void> {
      if (this.$store.state.auth.lock) return
      this.$store.state.auth.lock = true
      
      try {
        this.setLoader('deleteService', true)
        const obj = await this.$bridge.getObjectById(this.getData.$id)
        const p = await obj.getParent()
        let parent = p && p.cls != 'folder' ? p : []
        const d = await obj.delete()
        
        if (d) {      
          this.$store.dispatch('activeTree', parent)
          this.$emit('update')
          this.dialog.confirm = false
          this.setLoader('deleteService', false)
          this.$store.state.auth.lock = false
          this.$dialog.notify.success(this.$getTranslate('removal success'), { timeout: 5000 })
          this.$emit('close')
        } else {
          console.log('CREATE_SERVICE_BAR', 'deleteService', 'smth wrong', d)
          this.setLoader('deleteService', false)
          this.$store.state.auth.lock = false
          this.$dialog.notify.error(this.$getTranslate('delete error'), { timeout: 5000 })
        }
        this.$store.dispatch('setEditMode', false)
      } catch (err) {
        console.error('CATCH', 'CREATE_SERVICE_BAR', 'deleteService', err)
        this.$errorHandler(err)
        this.setLoader('deleteService', false)
        this.$store.state.auth.lock = false
      }
    },

    close(): void {
      this.reset()
      this.$emit('close')
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      this.showDoneButton = false
      this.devices = []
      this.removeDevices = []

      this.model = {
        location: { types: [], type: '', fields: [] },
        cabinet: { types: [], type: '', fields: [] },
        device: { types: [], type: '', models: [], model: '', fields: [] },
        module: { types: [], type: '', models: [], model: '', fields: [] },
      }

      this.state = { messages: { error: {} } }
      this.current = { entity: '' }
    },
  },
})
</script>

<style scoped>

</style>
